<template>
    <div>
        <div class="list">
            <div
                class="item"
                v-for="item in calcList"
                :key="item"
                :style="{marginLeft: configMap.get('marginLeft')}"
            >
                <div class="item-cover" @click="toMore(item)">
                    <van-image
                        class="cover-content"
                        :radius="configMap.get('radius')"
                        :width="configMap.get('width')"
                        :height="configMap.get('height')"
                        fit="cover"
                        :src="item.cover"
                    />
                    <van-icon
                        name="play-circle-o"
                        class="video-logo"
                        v-if="configMap.get('isVideo')"
                        :style="{lineHeight: configMap.get('height')}"
                    />
                </div>
                <div class="item-title" @click="toMore(item)">{{item.title}}</div>
            </div>
        </div>
        <empty v-if="!loading && isEmpty" />
    </div>
</template>

<script>
import Empty from '@/components/empty'
import { toRefs } from '@vue/runtime-core'
import { ellipsisString } from '@/utils/stringUtils'
import {Toast} from "vant";

export default {
    name: 'ResourceList',
    components: {
        Empty
    },
    props: {
        coverType: {
            type: String,
        },
        list: {
            type: Array,
            default: () => []
        },
        loading:{
            type:Boolean,
            require:false,
            default:false,
        }
    },
    methods:{
        toMore(item){
            if(!item.path) Toast.fail('未设置\npath')
            this.$router.push(item.path)
        }
    },
    computed:{
        calcList(){
            const list = this.list
            if(!list || !list.length) return []
            const calc = []
            list.forEach((item) => {
                calc.push({
                    ...item,
                    title:ellipsisString(item.title, this.configMap.get('max')),
                })
            })
            return calc
        },
        isEmpty(){
            return !this.list || !this.list.length
        }
    },
    setup(props) {
        // init cover size
        const { coverType } = toRefs(props)
        let configMap = new Map([
            ['isVideo', false],
        ])
        switch(coverType.value) {
            case 'relic':
                configMap.set('radius', '5px')
                configMap.set('width', '90vw')
                configMap.set('height', '46vw')
                configMap.set('marginLeft', '5vw')
                configMap.set('max', 21)
                break
            case 'book':
                configMap.set('radius', '5px')
                configMap.set('width', '29.3333vw')
                configMap.set('height', '43.5vw')
                configMap.set('marginLeft', '3vw')
                configMap.set('max', 6)
                break
            case 'video':
                configMap.set('isVideo', true)
                /* falls through */
            case 'story':
                configMap.set('radius', '5px')
                configMap.set('width', '45.5vw')
                configMap.set('height', '27vw')
                configMap.set('marginLeft', '3vw')
                configMap.set('max', 10)
                break
        }
        return {
            configMap,
        }
    }
}
</script>

<style scoped>
.list {
    margin-top: 30px;
}

.item {
    display: inline-block;
    margin-bottom: 30px;
}

.item-cover {
    position: relative;
}

.item-title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
}

.video-logo {
    font-size: 60px;
    font-weight: 600;
    position: absolute;
    width: 100%;
    text-align: center;
    color: #fff;
    left: 0;
    z-index: 10;
}
</style>
